module.exports = __webpack_public_path__ + "media/images/application/template/logoslider/logo-networkrail-ff77374a61a9c24641061171831cce20.png";